import { getClients, removeClient, addClient, updateClient } from "../services/clients";
import DataTable from "../components/Table/DataTable";
import { roles } from "../utils/roles";
import { ClientVisual } from "../components/Table/Visual";

const headCells = [
  {
    field: "name",
    headerName: "Name",
    sortable: true,
    editable: false,
    isOnTable: true,
    type: "textField",
    flex: 1,
    filterable: false,
    isRequired: true,
    isOnFilter: true,
    helperText: "Please provide a name.",
    renderCell: (params) => {
      const clientName = params.row.name;
      const clientVisual = params.row.visualPath;
      return <ClientVisual name={clientName} visual={clientVisual ? `${process.env.REACT_APP_PROXY}/assets/clients/${clientVisual}` : null} />;
    },
  },
  {
    field: "visualPath",
    headerName: "Visual",
    sortable: false,
    editable: false,
    isOnTable: false,
    type: "inputUpload",
    filterable: false,
    isOnFilter: false,
    isRequired: true,
  },
];

const entity = {
  tableId: "clients",
  label: "client",
};

const permissions = {
  read: [roles.ALL],
  delete: [roles.PM, roles.SALE, roles.ADMIN, roles.SUPERADMIN],
  create: [roles.PM, roles.SALE, roles.ADMIN, roles.SUPERADMIN],
  update: [roles.PM, roles.SALE, roles.ADMIN, roles.SUPERADMIN],
};

export default function ClientsPages() {
  return <DataTable permissions={permissions} entity={entity} fetchData={getClients} addData={addClient} deleteData={removeClient} updateData={updateClient} headCells={headCells} />;
}
